import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type NotificationSeverity = 'info' | 'success' | 'warning' | 'error'

export interface Notification {
  id: string
  severity: NotificationSeverity
  title: string
  body?: string
  timestamp: number
  read: boolean
  onClick?: () => void
}

interface NotificationStore {
  notifications: Notification[]
  addNotification: (n: Omit<Notification, 'id' | 'timestamp' | 'read'>) => void
  markRead: (id: string) => void
  markAllRead: () => void
  clear: () => void
  unreadCount: () => number
}

export const useNotificationStore = create<NotificationStore>()(
  persist(
    (set, get) => ({
      notifications: [],
      addNotification: (n) => {
        set((state) => {
          const newNotification: Notification = {
            ...n,
            id: crypto.randomUUID(),
            timestamp: Date.now(),
            read: false,
          }
          const newNotifications = [newNotification, ...state.notifications].slice(0, 50)
          return { notifications: newNotifications }
        })
      },
      markRead: (id) => {
        set((state) => ({
          notifications: state.notifications.map((n) =>
            n.id === id ? { ...n, read: true } : n
          ),
        }))
      },
      markAllRead: () => {
        set((state) => ({
          notifications: state.notifications.map((n) => ({ ...n, read: true })),
        }))
      },
      clear: () => {
        set({ notifications: [] })
      },
      unreadCount: () => {
        return get().notifications.filter((n) => !n.read).length
      },
    }),
    {
      name: 'heliumtracker-notifications',
      // We don't want to persist onClick handlers as they are functions
      partialize: (state) => ({
        notifications: state.notifications.map((n) => ({
          ...n,
          onClick: undefined,
        })),
      }),
    }
  )
)
